import Vue from 'vue'
import Vuex from 'vuex'
import home from './modules/home'
import merchantlist from './modules/merchantlist'

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    home,
    merchantlist
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js